<template>
  <section class="section discord-section">
    <b-row>
      <b-col md="6">
        <ul class="list-unstyled">
          <li class="media d-block d-sm-flex">
            <i class="pe-3x pe-7s-plugin accent mr-3 text-sm-right"></i>
            <div class="media-body mt-3 mt-sm-0 mt-lg-0 text-md-left">
              <h5>Request New Features</h5>
              <p class="mt-0 mb-5">
                Thought of a new feature you really want? Post it to
                <b>#feature-request</b> channel and we'll add it to our roadmap.
              </p>
            </div>
          </li>
          <li class="media d-block d-sm-flex">
            <i class="pe-3x pe-7s-bandaid accent mr-3 text-sm-right"></i>
            <div class="media-body mt-3 mt-sm-0 mt-lg-0 text-md-left">
              <h5>Report Bugs</h5>
              <p class="mt-0 mb-5">
                Found a bug that's really annoying? Feel free to report it in the
                <b>#bug-reports</b> channel
              </p>
            </div>
          </li>
          <li class="media d-block d-sm-flex">
            <i class="pe-3x pe-7s-like accent mr-3 text-sm-right"></i>
            <div class="media-body mt-3 mt-sm-0 mt-lg-0 text-md-left">
              <h5>Meet</h5>
              <p
                class="mt-0"
              >We're building a community of influencers. Use our Discord server to meet, share ideas, and catch-up with the other users of Unstitched.</p>
            </div>
          </li>
        </ul>
      </b-col>

      <b-col offset-md="1" md="5">
        <div
          class="card mb-2 float-lg-right shadow"
          style="max-width: 20rem;"
          data-aos="flip-right"
        >
          <img class="card-img-top" src="@/assets/img/stylists.png" alt="Card image cap" />
          <div class="card-body">
            <h4 class="card-title">Join the discussion</h4>
            <b-button
              size="lg"
              variant="outline-accent"
              class="sign-up mt-3 mb-2"
              target="_blank"
              rel="noopener noreferrer"
              href="https://discord.gg/dzcC8mm"
            >Connect</b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";

.discord-section {
  .display-4 {
    font-weight: 300;
    font-size: 3rem;
  }

  .accent {
    color: $primary-accent;
  }

  .sign-up {
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/DiscordSection.vue